import React from "react";
import { compose } from "recompose";
import * as forms from "app/forms";
import { injectIntl } from "react-intl";

const enhance = compose(
  forms.reduxField,
  forms.interactive,
  forms.unlabelled
);

export const Options = injectIntl(
  ({
    input,
    id,
    untouchField,
    showError,
    showSuccess,
    meta,
    data,
    label,
    rightElement,
    className,
    intl
  }) => {
    const ptIntent = showError
      ? "pt-intent-danger"
      : showSuccess && meta.active && "pt-intent-success";
    return (
      <div className="pt-select pt-fill">
        <select
          {...input}
          id={id}
          className={`pt-input ${ptIntent} ${className}`}
          onKeyUp={e => e.keyCode === 27 && untouchField()}
          onChange={e => {
            untouchField();
            input.onChange(e);
          }}
        >
          <option value={data.defaultValue} disabled>
            {`${intl.formatMessage({
              id: "text.select",
              defaultMessage: "Select"
            })} `}
            {data.key} ...
          </option>
          {data.options.map((option, index) => (
            <option
              value={option.value}
              key={option.key || option.value || index}
            >
              {option.label}
            </option>
          ))}
        </select>
      </div>
    );
  }
);

export default enhance(Options);



// WEBPACK FOOTER //
// ./src/app/proposals/fields/OptionsInput.js